import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import Planner from './Planner';

function Spinner() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f5f5f5' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#7bb23f', marginBottom: 12 }}>Lee Row s.r.o.</div>
        <div style={{ fontSize: 14, color: '#888' }}>Přihlašuji…</div>
      </div>
    </div>
  );
}

const isReadOnly = window.location.pathname === '/workers' || window.location.pathname === '/workers/';

export default function App() {
  const { instance, accounts, inProgress } = useMsal();

  // MsalProvider v5 zpracovává handleRedirectPromise() interně — nevoláme ho manuálně.
  // loginRedirect voláme jen tehdy, když neprobíhá žádná interakce (StrictMode-safe).
  useEffect(() => {
    if (accounts.length === 0 && inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest);
    }
  }, [accounts, inProgress, instance]);

  // Zobrazuj spinner, dokud probíhá interakce (redirect, token refresh…)
  if (inProgress !== InteractionStatus.None || accounts.length === 0) return <Spinner />;

  return <Planner isReadOnly={isReadOnly} />;
}
